import { api } from './api';

// Extrai o nome do arquivo a partir de uma URL
function extrairFilename(url) {
  return url.split('/').pop().split('?')[0];
}

// Baixa um arquivo como blob autenticado e dispara o download no navegador.
// url: pode ser absoluta (https://...) ou relativa — axios ignora baseURL quando absoluta.
// filename: opcional; se omitido, extrai do URL.
export async function downloadAuthenticatedFile(url, filename) {
  const response = await api.get(url, { responseType: 'blob' });

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', filename || extrairFilename(url));
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
}

// Busca um arquivo como blob autenticado e retorna uma Object URL.
// O caller é responsável por chamar URL.revokeObjectURL quando não precisar mais.
export async function fetchAuthenticatedBlobUrl(url) {
  const response = await api.get(url, { responseType: 'blob' });
  return window.URL.createObjectURL(new Blob([response.data]));
}
